import PropTypes from 'prop-types';
import { Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import Iconify from '../../../components/iconify';
import TeamCalendar from './TeamCalendar';

/**
 * Opened from a leave/WFH details page so the approver can see the employee's other
 * leave and WFH around this request (and, on demand, the rest of the team) before deciding.
 */
const EmployeePlanDialog = ({ open, onClose, request, kind, showWfh }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
    <DialogTitle>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography variant="h6">
          {request?.employee?.userName || request?.employee?.email || 'Employee'}&apos;s leave & WFH plan
        </Typography>
        <IconButton onClick={onClose} aria-label="Close">
          <Iconify icon="eva:close-fill" />
        </IconButton>
      </Stack>
    </DialogTitle>
    <DialogContent dividers>
      {open && request && (
        <TeamCalendar
          showWfh={showWfh}
          initialMonth={request.startDate}
          focusUserId={request.userId}
          highlight={{ kind, id: request.id }}
        />
      )}
    </DialogContent>
  </Dialog>
);

EmployeePlanDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  request: PropTypes.object,
  kind: PropTypes.oneOf(['leave', 'wfh']),
  showWfh: PropTypes.bool,
};

export default EmployeePlanDialog;
